import type { StaticPageDocument } from "~/feature/staticInfo/types/staticPageContent.types";

import data from "./data.json";
import disclaimer from "./disclaimer.json";
import privacyPolicy from "./privacy-policy.json";
import termsOfUse from "./terms-of-use.json";

export const staticPageContent = {
  data: data as StaticPageDocument,
  disclaimer: disclaimer as StaticPageDocument,
  privacyPolicy: privacyPolicy as StaticPageDocument,
  termsOfUse: termsOfUse as StaticPageDocument,
} as const;
